<template>
  <div style="height: 302px;">
    <div class="title-box">
      <div class="text-title1">近7天统计</div>

      <router-link class="text-right1" tag="div" to="/sportCount" >
        <span>历史步数</span>
        <van-icon name="arrow" />
      </router-link>
    </div>
    <!-- 折线图开始 -->
    <div id="sevenDate" class="echart-box">
      <ve-line :data="chartData" :extend="chartExtend" :settings="chartSettings" :colors="colors" height="350px"></ve-line>
    </div>
    <div v-if="noDate">
      <van-empty
        class="custom-image"
        :image="require('../../../assets/images/txt_noDate.png')"
        description="暂无数据"
      />
    </div>
    <!-- 折线图结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import VeLine from "v-charts/lib/line";
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  props: {
    eachrtsDate: {
      type: Object
    }
  },
  components: {
    VeLine
  },
  data() {
    (this.chartSettings = {
      yAxisName: ["单位：w"]
    }),
      (this.colors = ["#5B8FF9"]);
    return {
      noDate: false,
      themeColor: {
        color: "#5B8FF9"
      },
      chartExtend: {
        series: {
          smooth: false,
          symbolSize: 6,
          symbol: "circle"
        },
        legend: {
          data: []
        },
        calculable: true,
        lineStyle: {
          // 系列级个性化折线样式
          width: 2,
          type: "solid",
          color: "#5B8FF9" // 折线的颜色
        },
        xAxis: {
          axisLabel: {
            margin: 15, //距离
            interval: 0,
            rotate: 30 //倾斜度
          },
          // name: "无法",
          // nameLocation: "end",
          triggerEvent: true
        }
      },
      chartData: {
        columns: ["day", "步数"],
        rows: [
          // { day: "1日", 步数: 123 },
          // { day: "2日", 步数: 1223 },
          // { day: "3日", 步数: 2123 },
          // { day: "4日", 步数: 4123 },
          // { day: "5日", 步数: 3123 },
          // { day: "6日", 步数: 7123 }
        ]
      }
    };
  },
  watch: {
    // 将后台返回的数据转换成为自己想要的数据
    eachrtsDate(val) {
      let that = this;
      console.log(val);
      for (let index in val.timeData) {
        console.log(val.timeData[index]);
        const titeObj = { day: val.timeData[index], 步数: val.stepData[index] };
        that.chartData.rows.push(titeObj);
        that.chartData.rows[index].day = moment(val.timeData[index]).format(
          "DD" + "日"
        );
      }
      console.log(that.chartData);
    }
  },
  created() {
    this.chartData = {
      columns: ["day", "步数"],
      rows: [
        // { day: "1日", 步数: 123 },
        // { day: "2日", 步数: 1223 },
        // { day: "3日", 步数: 2123 },
        // { day: "4日", 步数: 4123 },
        // { day: "5日", 步数: 3123 },
        // { day: "6日", 步数: 7123 }
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';

.echart-box {
  margin-top: -10px;
}

.title-box {
  display: flex;
}

.text-title1 {
  height: 24px;
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(53, 53, 53, 1);
  line-height: 24px;
}

.van-icon {
  color: #CACAD2;
  width: 22px;
  font-size: 20px;
  height: 22px;
  display: inline-block;
  vertical-align: text-top;
}

.text-right1 {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(41, 190, 188, 1);
  line-height: 20px;
  flex: 1;
  text-align: right;
}
</style>